export default "/images/vendor/flag-icon-css/flags/4x3/gb.svg?ba1c7f5df0dd4173c951a644c65e02df";